<template>
  <div :class="['comment-layout', $store.state.breakpoint.smAndDown || showActions ? '-show-actions' : '']">
    <div class="_left">
      <user-avatar
        v-if="showMeta"
        :user="user"
        :size="20"
      />
    </div>
    <div class="_right">
      <div
        v-if="showMeta && !hideTitle"
        class="_header"
      >
        <div class="_header-container">
          <span class="_name">
            {{ user.firstName }} {{ user.lastName }}
          </span>
          <span
            v-if="timestamp !== ''"
            class="_timestamp"
          >{{ timestamp }}</span>
          <slot name="post-title" />
        </div>
      </div>
      <div class="_body">
        <slot />
      </div>
    </div>
    <div class="_floating-actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import UserAvatar from 'shared/components/UserAvatar.vue';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useUsers from '@/composables/user/users';

export default {
  name: 'CommentLayout',
  props: {
    creator: {
      type: Object,
      default: () => ({}),
    },
    showMeta: {
      type: Boolean,
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    timestamp: {
      type: String,
      default: '',
    },
    generated: {
      type: Boolean,
      default: false,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { mooncampBotUser, deletedUser } = useUsers();
    const { loggedInUser } = useLoggedInUser();
    return { mooncampBotUser, deletedUser, loggedInUser };
  },
  components: { UserAvatar },
  computed: {
    user() {
      if (this.generated) {
        return this.mooncampBotUser;
      }

      if (this.creator === null) {
        return this.deletedUser;
      }

      return this.creator;
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .comment-layout {
    position: relative;
    display: flex;
    gap: .6rem;

    ._left {
      flex: 0 0 2.4rem;
      margin-top: .3rem;
    }

    ._right {
      flex: 1 1 auto;
      max-width: calc(100% - 3rem);

      ._header {
        height: 2.8rem;

        ._header-container {
          display: flex;
          gap: 0.6rem;
          align-items: center;

          ._name {
            font-weight: $font-weight-semibold;
            overflow-x: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          ._timestamp {
            font-size: $font-size-2;
            color: $font-color-secondary;
            overflow-x: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    ._floating-actions {
      position: absolute;
      right: 0;
      visibility: hidden;
    }

    &:hover,
    &.-show-actions {
      ._floating-actions {
        visibility: visible;
      }
    }
  }
</style>
